import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'translations';
import { mapStateToProps } from 'app/components/book-trip/BookHeader';

import { Container, Item, Icon, Title } from './elements';


const messages = {
  cancellation: { id: 'ASSURANCES.USER.CANCELLATION' },
  tracking: { id: 'ASSURANCES.USER.TRACKING' },
  taxes: { id: 'ASSURANCES.USER.TAXES' },
  customer: { id: 'ASSURANCES.USER.CUSTOMER' }
};

const Assurance = ({ iconSrc, message }) => (
  <Item>
    <Icon $src={iconSrc} />
    <Title>
      <FormattedMessage {...messages[message]} />
    </Title>
  </Item>
);

// TODO: move to Flow types
// Assurance.propTypes = {
//   iconSrc: PropTypes.string,
//   message: PropTypes.string,
//   modifiers: PropTypes.object
// };

const UserAssurances = ({ mode, freeCancellation }) => {
  return (
    <Container>
      {(mode === 'srp' || freeCancellation) && (
        <Assurance iconSrc={require('./assets/assurance-1.png')} message="cancellation" />
      )}
      <Assurance iconSrc={require('./assets/assurance-2.png')} message="tracking" />
      <Assurance iconSrc={require('./assets/assurance-3.png')} message="taxes" />
      <Assurance iconSrc={require('./assets/assurance-4.png')} message="customer" />
    </Container>
  );
};

// TODO: move to Flow types
// UserAssurances.propTypes = {
//   freeCancellation: PropTypes.bool,
//   mode: PropTypes.oneOf(['btp', 'srp'])
// };

export default connect(mapStateToProps)(UserAssurances);
